export default {
  width: '98px',
  servicePhone: '400-618-3638',
  primaryColor: '#e1251b',
  nav: {
    /*
    bgNav: '',
    textNavColor: '',
    bgMenu: '#fff',
    textMenuColor: '',
    activeTextMenuColor: '',
    */
  },
}
